import styles from './WhereField.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Autosuggest } from 'seek-style-guide/react';
import { parse as parseAutosuggestMatches } from 'autosuggest-highlight';

import {
  whereFieldFocused,
  whereFieldTyped,
  updateWhereField,
  fetchWhereSuggestions,
  clearWhereSuggestions,
  getPersonalisedLocationSuggestions
} from 'store/search/search';

function mapStateToProps({ search, location }) {
  return {
    value: search.whereField,
    suggestions: search.whereSuggestions,
    locale: location.locale
  };
}

const mapDispatchToProps = {
  whereFieldFocused,
  whereFieldTyped,
  updateWhereField,
  fetchWhereSuggestions,
  clearWhereSuggestions,
  getPersonalisedLocationSuggestions
};

@connect(mapStateToProps, mapDispatchToProps)
export default class WhereField extends Component {
  static propTypes = {
    value: PropTypes.string,
    suggestions: PropTypes.array.isRequired,
    locale: PropTypes.string.isRequired,
    whereFieldFocused: PropTypes.func.isRequired,
    whereFieldTyped: PropTypes.func.isRequired,
    updateWhereField: PropTypes.func.isRequired,
    fetchWhereSuggestions: PropTypes.func.isRequired,
    clearWhereSuggestions: PropTypes.func.isRequired,
    getPersonalisedLocationSuggestions: PropTypes.func.isRequired,

    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    labelProps: PropTypes.object,
    onSuggestionSelected: PropTypes.func.isRequired,
    onInputBlur: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired
  };

  static defaultProps = {
    value: '',
    labelProps: {}
  };

  constructor() {
    super();

    this.onFocus = this.onFocus.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.storeInputReference = this.storeInputReference.bind(this);
  }

  storeInputReference(autosuggest) {
    if (autosuggest !== null) {
      this.input = autosuggest.input;
    }
  }

  onSuggestionSelected(event, { suggestion, suggestionValue }) {
    event.preventDefault();
    this.props.onSuggestionSelected({ suggestion, suggestionValue });
  }

  renderSuggestion(suggestion) {
    return (
      <span>
        {
          suggestion.displayParts ?
            suggestion.displayParts
              .map(({ text, matches }) => parseAutosuggestMatches(text, matches))
              .map((highlightRules, partIndex) =>
                <span key={partIndex} className={styles.suggestionPart}>
                  {
                    highlightRules.map(({ text, highlight }, ruleIndex) => (
                      <span key={ruleIndex} className={highlight && styles.suggestionPartMatch}>
                        {text}
                      </span>
                    ))
                  }
                &nbsp;</span>
              ) :
            suggestion.displayText
        }
      </span>
    );
  }

  getSuggestionValue(suggestion) {
    return suggestion.displayText;
  }

  shouldRenderSuggestions() {
    return true;
  }

  onFocus() {
    this.props.whereFieldFocused();
  }

  onKeyDown() {
    this.props.whereFieldTyped();
  }

  onChange(event, { newValue }) {
    this.props.updateWhereField(newValue);
  }

  onClear() {
    this.props.updateWhereField('');
    this.props.onClear();
    this.props.getPersonalisedLocationSuggestions();
  }

  onSuggestionsFetchRequested({ value }) {
    if (value.trim() === '') {
      this.props.getPersonalisedLocationSuggestions();
    } else {
      const { locale } = this.props;

      this.props.fetchWhereSuggestions({ value, locale });
    }
  }

  onSuggestionsClearRequested() {
    this.props.clearWhereSuggestions();
  }

  renderSectionTitle(section) {
    return section.sectionName;
  }

  getSectionSuggestions(section) {
    return section.suggestions;
  }

  render() {
    const { value, suggestions, locale, id, name, label, labelProps, onInputBlur } = this.props;
    const inputProps = {
      name,
      value,
      className: styles.input,
      type: 'search',
      spellCheck: 'false',
      'data-automation': id,
      placeholder: (locale.toLowerCase() === 'nz' ? 'Enter suburb, town or city' : 'Enter suburb, city, or region'),
      onFocus: this.onFocus,
      onKeyDown: this.onKeyDown,
      onChange: this.onChange,
      onBlur: onInputBlur
    };

    return (
      <div data-automation="whereFieldOptions">
        <Autosuggest
          ref={this.storeInputReference}
          className={styles.root}
          inputProps={inputProps}
          onClear={this.onClear}
          id={id}
          label={label}
          labelProps={labelProps}
          autosuggestProps={{
            multiSection: true,
            onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.onSuggestionsClearRequested,
            getSuggestionValue: this.getSuggestionValue,
            renderSuggestion: this.renderSuggestion,
            onSuggestionSelected: this.onSuggestionSelected,
            shouldRenderSuggestions: this.shouldRenderSuggestions,
            renderSectionTitle: this.renderSectionTitle,
            getSectionSuggestions: this.getSectionSuggestions,
            suggestions
          }}
          suggestionsContainerClassName={styles.suggestionsContainer}
        />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/SearchBar/components/WhereField/WhereField.js
 **/